import {EducationResource} from '@/common/api/api-raw-types';
import {Education} from '../../../domain/Profile';

export function toEducation(educationResource: EducationResource): Education {
    return {
        content: educationResource.content,
        description: educationResource.description,
        graduationYear: educationResource.graduationYear,
        title: educationResource.title,
    };
}

export function sortByGraduationYear(educations: EducationResource[]) {
    return educations.sort((a, b) => {
        if (a.graduationYear === null) {
            return b.graduationYear === null ? 0 : -1;
        }

        if (b.graduationYear === null) {
            return 1;
        }

        return b.graduationYear - a.graduationYear;
    });
}
